/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasGridCellBase } from "./CanvasGridCellBase";
import { CanvasTemplateCellContainer } from "./CanvasTemplateCellContainer";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasTemplateCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasTemplateCell, _super);
    function CanvasTemplateCell(a) {
        var _this = _super.call(this, a) || this;
        _this.c3 = null;
        _this.c3 = new CanvasTemplateCellContainer(a);
        return _this;
    }
    Object.defineProperty(CanvasTemplateCell.prototype, "c4", {
        get: function () {
            return this.c3;
        },
        enumerable: true,
        configurable: true
    });
    CanvasTemplateCell.prototype.get_aa = function () {
        return true;
    };
    CanvasTemplateCell.prototype.c5 = function () {
        this.b1();
    };
    CanvasTemplateCell.$t = markType(CanvasTemplateCell, 'CanvasTemplateCell', CanvasGridCellBase.$);
    return CanvasTemplateCell;
}(CanvasGridCellBase));
export { CanvasTemplateCell };
//# sourceMappingURL=CanvasTemplateCell.js.map
